import { Component, inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { loadSubscription } from '../../../store/auth/auth.actions'
import { selectUser } from '../../../store/auth/auth.state'
import { take } from 'rxjs'

@Component({
  selector: 'app-payment-success',
  imports: [],
  templateUrl: './payment-success.component.html',
  styleUrl: './payment-success.component.scss'
})
export class PaymentSuccessComponent {
  store = inject(Store)

  constructor() {
    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(usr => {
        if (usr) {
          //This subscription action is dispatched to update the subscription details in the store
          this.store.dispatch(loadSubscription({ businessId: usr.businessId }))
        }
      })
  }
}
